'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('sonyCandidate', {
      url: '/sonyCandidate',
      template: '<sctab></sctab>',
      authenticate: 'admin'
    });
}
